<div *ngIf="(!row.isVoted || isInvestmentCommitteeAdmin) && !isMobile; else votingsummary" class="h-full flex align-items-center justify-content-between">
    <div class="flex align-items-center">
        <a (click)="voteForCompany(row)" 
           tooltipPosition="bottom" 
           placeholder="Bottom" 
           pTooltip="Vote Now" 
           style="cursor: pointer; font-size: 20px;">
            <span class="icon-thumbs-up"></span>
        </a>
        <div *ngIf="isInvestmentCommitteeAdmin">
            <div *ngIf="votingSummaryEnable(row.workflows)"
                 class="star-tag m-width {{ votingClassesWorkflow(row.workflows) }} ml-2"
                 (click)="showVotingStats(row)">
                <span class="star-circle">
                    <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.51965 1.99998L4.09265 4.36498L5.47865 1.99998L7.61265 1.99998L5.13765 5.92698L7.66765 9.72198H5.47865L3.92765 7.38998L2.56365 9.72198H0.429649L2.88265 5.82798L0.33065 1.99998L2.51965 1.99998Z" fill="white"/>
                        <path d="M7.93165 0.899976L0.0666504 0.899975L0.0666504 0.349976L7.93165 0.349976V0.899976Z" fill="white"/>
                    </svg>
                </span>
                <span class="star-value">
                    {{ votingSummary(row.workflows) }}
                </span>
            </div>
        </div>
    </div>
    <bpc-menu-native-primeng-v2 [items]="menuItems" *ngIf="isInvestmentCommitteeAdmin && !isMobile">
        <span
          *ngIf="authService.isInvestor || authService.isAdmin"
          class="pi pi-ellipsis-v p-2 cursor-pointer ml-6"
          (click)="onMenuClick(row)"
        >
        </span>
    </bpc-menu-native-primeng-v2>
</div>

<div class="flex items-center justify-between"></div>

<ng-template #votingsummary>
    <div *ngIf="isMobile" class="flex items-center justify-between">
        <div>
            <div *ngIf="votingSummaryEnable(row.workflows)"
                 class="star-tag m-width {{ votingClassesWorkflow(row.workflows) }}">
                <span class="star-circle">
                    <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.51965 1.99998L4.09265 4.36498L5.47865 1.99998L7.61265 1.99998L5.13765 5.92698L7.66765 9.72198H5.47865L3.92765 7.38998L2.56365 9.72198H0.429649L2.88265 5.82798L0.33065 1.99998L2.51965 1.99998Z" fill="white"/>
                        <path d="M7.93165 0.899976L0.0666504 0.899975L0.0666504 0.349976L7.93165 0.349976V0.899976Z" fill="white"/>
                    </svg>
                </span>
                <span class="star-value">
                    {{ votingSummary(row.workflows) }}
                </span>
            </div>
        </div>
    </div>
    <div *ngIf="!isMobile" class="flex items-center justify-between">
            <div>
            <div *ngIf="votingSummaryEnable(row.workflows)"
                 class="star-tag m-width {{ votingClassesWorkflow(row.workflows) }}"
                 (click)="showVotingStats(row)">
                <span class="star-circle">
                    <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.51965 1.99998L4.09265 4.36498L5.47865 1.99998L7.61265 1.99998L5.13765 5.92698L7.66765 9.72198H5.47865L3.92765 7.38998L2.56365 9.72198H0.429649L2.88265 5.82798L0.33065 1.99998L2.51965 1.99998Z" fill="white"/>
                        <path d="M7.93165 0.899976L0.0666504 0.899975L0.0666504 0.349976L7.93165 0.349976V0.899976Z" fill="white"/>
                    </svg>
                </span>
                <span class="star-value">
                    {{ votingSummary(row.workflows) }}
                </span>
            </div>
        </div>
    </div>
</ng-template>